/**
 * @Create idler.zhu(zqc.sunny@aliyun.com)
 * @CreateDate  2017/10/27
 */
import * as urls from '../config/urls';
import * as utils from '../utils/fetch';

/**
 * get homepage data async request
 */
export const getHome = () => {
  return utils.get(urls.getHome);
}

/**
 * get homepage hot product data async request
 */
export const getHot = () => {
  return utils.get(urls.getHot);
}

/**
 * get homepage data by category id async request
 */
export const getHomeByCid = (cid, current=1) => {
  return utils.get(urls.getHome, {cid: cid, current: current});
}

/**
 * get category data async request
 */
export const getCategory = (cid) => {
  return utils.get(urls.getCategory, {cid: cid});
}

/**
 * get product data by category id & brand id & page
 */
export const getProduct = (cid=1, bid=17, current=1) => {
  return utils.get(urls.getProduct, {cid: cid, bid: bid, current: current});
}

/**
 * get page info data async request
 */
export const getPageInfo = (isPreview) => {
  const query = isPreview ? {type: 1, isPreview: 1} : {type: 1};
  return utils.get(urls.pageInfo, query);
}



// WEBPACK FOOTER //
// ./src/services/home.js